import { setSentryUser, clearSentryUser } from './sentry';

/**
 * Update Sentry user context when user data changes
 * Call this in useEffect whenever user data is fetched or updated
 */
export const updateSentryUserContext = (user) => {
  if (!user) {
    clearSentryUser();
    return;
  }

  // Extract user info - adjust to match your actual user object structure
  const userId = user.id || user.user_id;
  const email = user.email;
  const username = user.username || user.name || user.business_name;

  if (userId) {
    setSentryUser(userId, email, username);
  }
};

/**
 * Clear Sentry user context on logout
 */
export const clearSentryUserContext = () => {
  clearSentryUser();
};

export default { updateSentryUserContext, clearSentryUserContext };
